import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {translations} from 'presentation/translations-new';

const {title} = translations['pt-br'].privateFlow.operationalCost;

export function OperationalCostWrapper() {
	return <PageWrapperLayout title={title} />;
}
